import { useState } from 'react';

interface ThemeStore {
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
}

let globalTheme: 'light' | 'dark' = 'dark';
const listeners = new Set<(theme: 'light' | 'dark') => void>();

const useThemeStore = (): ThemeStore => {
  const [theme, setThemeState] = useState(globalTheme);

  const setTheme = (newTheme: 'light' | 'dark') => {
    globalTheme = newTheme;
    for (const listener of listeners) {
      listener(newTheme);
    }
  };

  useState(() => {
    listeners.add(setThemeState);
    return () => {
      listeners.delete(setThemeState);
    };
  });

  return { theme, setTheme };
};

export default useThemeStore;
